export default [
  {
    name: 'home',
    path: '/',
    title: 'De Tweede Kamer',
  },
  {
    name: 'agenda',
    path: '/agenda',
    title: 'Agenda',
  },
  {
    name: 'index-for-date',
    path: '/agenda/:date',
    title: 'Agenda',
  },
  {
    name: 'votings',
    path: '/stemmingen',
    title: 'Stemmingen van deze week',
  },
  {
    name: 'location-plenary',
    path: '/zalen/plenaire-zaal',
    title: 'Over de Plenaire Zaal',
  },
  {
    name: 'parliament-members',
    path: '/personen/kamerleden',
    title: 'Kamerleden',
  },
  {
    name: 'cabinet-members',
    path: '/personen/kabinetsleden',
    title: 'Kabinetsleden',
  },
  {
    name: 'location-embedded',
    path: '/zaal-embedded/:location',
    title: 'Zaal embed',
  },
  {
    name: 'location-embedded-audio',
    path: '/zaal-embedded-audio/:location',
    title: 'Zaal embed (audio)',
  },
  {
    name: 'debate',
    path: '/:date/:category/:location/:debate',
  },
  {
    name: 'debate-subject',
    path: '/:date/:category/:location/:debate/onderwerp',
  },
  {
    name: 'debate-video',
    path: '/:date/:category/:location/:debate/video',
  },
  {
    name: 'debate-markers',
    path: '/:date/:category/:location/:debate/markeringen',
  },
  {
    name: 'debate-location',
    path: '/:date/:category/:location/:debate/in-de-zaal',
  },
  {
    name: 'debate-documents',
    path: '/:date/:category/:location/:debate/stukken',
  },
  {
    name: 'debate-embedded',
    path: '/:date/:category/:location/:debate/embedded',
  },
  {
    name: 'about',
    path: '/about',
    title: 'Over Debat Direct',
  },
  {
    name: 'licenses',
    path: '/licenties',
    title: 'Licenties',
  },
  {
    name: 'accessibility',
    path: '/toegankelijkheid',
    title: 'Toegankelijkheidsverklaring',
  },
  {
    name: 'disclaimer',
    path: '/disclaimer',
    title: 'Disclaimer',
  },
  {
    name: 'security-policy',
    path: '/security-policy',
    title: 'Security Policy',
  },
  {
    name: 'support',
    path: '/support/:faq?',
    title: 'Support',
  },
  {
    name: 'kamerbeelden',
    path: '/kamerbeelden',
    title: 'Kamerbeelden',
  },
  {
    name: 'downloads',
    path: '/downloads',
    title: 'Downloads',
  },
  {
    name: 'search',
    path: '/search',
    title: 'Zoek debatten',
  },
  {
    name: 'not-found',
    path: '/not-found',
    title: 'Niet Gevonden',
  },
  {
    name: 'error',
    path: '*',
    title: 'Foutmelding',
  },
];
